var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1020,
    zoomAndPan: "magnify",
    viewBox: "0.238281 589.40625 1020.559 542.594",
    height: 542,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d05520bf04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.238281 589.40625 L 1020.796875 589.40625 L 1020.796875 1132 L 0.238281 1132 Z M 0.238281 589.40625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "865e2ae16d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.238281 606 L 23 606 L 23 612 L 0.238281 612 Z M 0.238281 606 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d05520bf04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M 165.675781 589.394531 L 0.265625 589.394531 L 0.265625 630.621094 L 165.675781 630.621094 C 193.015625 630.621094 215.261719 651.539062 215.261719 677.25 L 215.261719 793.363281 C 215.261719 841.804688 256 881.21875 306.078125 881.21875 L 427.304688 881.21875 C 454.644531 881.21875 476.890625 902.132812 476.890625 927.84375 L 476.890625 985.898438 C 476.890625 1025.042969 492.757812 1061.792969 521.5625 1089.382812 C 550.125 1116.742188 588.039062 1131.808594 628.320312 1131.808594 C 668.601562 1131.808594 706.519531 1116.742188 735.082031 1089.382812 C 763.886719 1061.792969 779.75 1025.042969 779.75 985.898438 L 779.75 927.84375 C 779.75 902.132812 801.992188 881.21875 829.335938 881.21875 L 1020.761719 881.21875 L 1020.761719 839.988281 L 829.335938 839.988281 C 779.261719 839.988281 738.519531 879.398438 738.519531 927.84375 L 738.519531 985.898438 C 738.519531 1043.621094 689.089844 1090.582031 628.320312 1090.582031 C 567.554688 1090.582031 518.121094 1043.621094 518.121094 985.898438 L 518.121094 927.84375 C 518.121094 879.398438 477.378906 839.988281 427.304688 839.988281 L 306.078125 839.988281 C 278.734375 839.988281 256.488281 819.074219 256.488281 793.363281 L 256.488281 677.25 C 256.488281 628.804688 215.75 589.394531 165.675781 589.394531 Z M 165.675781 589.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 68.746094 606.964844 L 46.371094 606.964844 L 46.371094 611.699219 L 68.746094 611.699219 Z M 68.746094 606.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 291.609375 860.910156 L 292.152344 858.097656 L 291.605469 860.90625 C 284.027344 859.441406 276.726562 856.800781 269.964844 853.078125 L 272.25 848.933594 C 278.578125 852.417969 285.414062 854.894531 292.507812 856.265625 L 293.152344 856.386719 L 292.296875 861.039062 Z M 291.609375 860.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 486.175781 894.910156 L 490.230469 892.476562 C 494.226562 899.113281 497.050781 906.386719 498.570312 913.980469 L 493.933594 914.910156 C 492.515625 907.847656 489.890625 901.082031 486.175781 894.910156 Z M 486.175781 894.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 338.070312 857.5625 L 315.699219 857.5625 L 315.699219 862.292969 L 338.070312 862.292969 Z M 338.070312 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 233.53125 794.4375 L 235.738281 794.378906 L 233.53125 794.4375 C 233.515625 793.855469 233.507812 793.273438 233.507812 792.6875 L 233.507812 772.003906 L 238.242188 772.003906 L 238.242188 792.6875 C 238.242188 793.230469 238.246094 793.773438 238.261719 794.3125 L 238.28125 794.96875 L 233.554688 795.140625 C 233.546875 794.90625 233.539062 794.671875 233.53125 794.4375 Z M 233.53125 794.4375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 238.242188 725.898438 L 233.507812 725.898438 L 233.507812 748.949219 L 238.242188 748.949219 Z M 238.242188 725.898438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 250.882812 837.875 L 252.421875 836.5 L 250.878906 837.875 C 245.722656 832.105469 241.574219 825.507812 238.605469 818.359375 L 242.976562 816.550781 C 245.742188 823.207031 249.605469 829.351562 254.410156 834.726562 L 254.851562 835.214844 L 251.34375 838.394531 Z M 250.882812 837.875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 471.214844 877.71875 C 465.609375 873.164062 459.316406 869.527344 452.570312 866.941406 L 454.265625 862.523438 C 461.476562 865.289062 468.207031 869.175781 474.199219 874.046875 L 472.90625 875.640625 L 474.203125 874.046875 L 474.742188 874.492188 L 471.722656 878.136719 Z M 471.214844 877.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 384.175781 857.5625 L 361.800781 857.5625 L 361.800781 862.292969 L 384.175781 862.292969 Z M 384.175781 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 430.183594 862.347656 C 429.234375 862.3125 428.265625 862.292969 427.304688 862.292969 L 407.910156 862.292969 L 407.910156 857.5625 L 427.304688 857.5625 C 428.328125 857.5625 429.363281 857.582031 430.375 857.621094 L 430.28125 859.988281 L 430.378906 857.621094 L 431.078125 857.652344 L 430.839844 862.378906 Z M 430.183594 862.347656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 761.5 951.441406 L 756.769531 951.441406 L 756.769531 973.816406 L 761.5 973.816406 Z M 761.5 951.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 230.417969 657.148438 L 230.414062 657.148438 C 228.164062 650.304688 224.769531 643.890625 220.367188 638.1875 L 224.117188 635.304688 C 228.84375 641.433594 232.496094 648.320312 234.910156 655.671875 C 234.984375 655.894531 235.054688 656.117188 235.128906 656.339844 L 230.617188 657.769531 Z M 230.417969 657.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 238.242188 679.792969 L 233.507812 679.792969 L 233.507812 702.84375 L 238.242188 702.84375 Z M 238.242188 679.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 160.953125 606.964844 L 138.578125 606.964844 L 138.578125 611.699219 L 160.953125 611.699219 Z M 160.953125 606.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 203.570312 622.757812 L 204.894531 620.707031 L 203.570312 622.757812 C 197.496094 618.839844 190.84375 615.90625 183.859375 614.054688 L 185.074219 609.484375 C 192.539062 611.460938 199.644531 614.597656 206.132812 618.78125 C 206.332031 618.910156 206.527344 619.039062 206.722656 619.167969 L 204.121094 623.117188 Z M 203.570312 622.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 114.847656 606.964844 L 92.476562 606.964844 L 92.476562 611.699219 L 114.847656 611.699219 Z M 114.847656 606.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 829.335938 862.292969 C 824.058594 862.289062 818.800781 862.875 813.65625 864.035156 L 812.609375 859.417969 C 818.097656 858.183594 823.707031 857.558594 829.335938 857.5625 L 835.371094 857.5625 L 835.371094 862.292969 Z M 829.335938 862.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 760.863281 997.761719 C 760.09375 1005.332031 758.621094 1012.808594 756.464844 1020.105469 L 751.929688 1018.761719 C 754.003906 1011.75 755.417969 1004.558594 756.160156 997.28125 L 759.085938 997.582031 L 756.160156 997.277344 L 756.222656 996.625 L 760.933594 997.066406 Z M 760.863281 997.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 761.5 927.167969 L 761.5 927.710938 L 756.769531 927.710938 L 756.769531 927.167969 C 756.761719 919.609375 758.039062 912.101562 760.539062 904.96875 L 762.769531 905.753906 L 760.539062 904.96875 L 760.777344 904.304688 L 765.222656 905.917969 L 765 906.539062 C 762.675781 913.167969 761.492188 920.140625 761.5 927.167969 Z M 761.5 927.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 792.515625 872.671875 C 786.378906 876.464844 780.890625 881.21875 776.261719 886.761719 L 772.632812 883.730469 C 777.578125 877.800781 783.453125 872.707031 790.027344 868.648438 L 791.128906 870.429688 L 790.027344 868.648438 L 790.625 868.285156 L 793.078125 872.328125 Z M 792.515625 872.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 881.472656 857.5625 L 859.101562 857.5625 L 859.101562 862.292969 L 881.472656 862.292969 Z M 881.472656 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1019.789062 857.5625 L 997.417969 857.5625 L 997.417969 862.292969 L 1019.789062 862.292969 Z M 1019.789062 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 927.582031 857.5625 L 905.203125 857.5625 L 905.203125 862.292969 L 927.582031 862.292969 Z M 927.582031 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 973.683594 857.5625 L 951.3125 857.5625 L 951.3125 862.292969 L 973.683594 862.292969 Z M 973.683594 857.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 513.820312 1050.464844 C 509.804688 1044.003906 506.382812 1037.195312 503.605469 1030.113281 L 508.011719 1028.386719 C 510.683594 1035.199219 513.972656 1041.753906 517.835938 1047.96875 L 518.191406 1048.535156 L 514.183594 1051.046875 Z M 513.820312 1050.464844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 545.234375 1085.003906 C 539.203125 1080.386719 533.585938 1075.253906 528.4375 1069.667969 L 531.917969 1066.464844 C 536.878906 1071.847656 542.296875 1076.796875 548.113281 1081.25 L 546.707031 1083.082031 L 548.113281 1081.25 L 548.636719 1081.648438 L 545.785156 1085.425781 Z M 545.234375 1085.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 499.871094 938.089844 L 495.140625 938.089844 L 495.140625 961.140625 L 499.871094 961.140625 Z M 499.871094 938.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 497.046875 1006.863281 C 495.777344 999.71875 495.140625 992.480469 495.140625 985.222656 L 495.140625 984.195312 L 499.871094 984.195312 L 499.871094 985.222656 C 499.871094 992.199219 500.484375 999.164062 501.703125 1006.03125 L 501.824219 1006.6875 L 497.171875 1007.542969 Z M 497.046875 1006.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 716.347656 1076.714844 L 718.5 1079.164062 C 712.804688 1084.191406 706.6875 1088.71875 700.21875 1092.703125 L 697.738281 1088.675781 C 703.976562 1084.832031 709.878906 1080.464844 715.371094 1075.617188 L 715.871094 1075.175781 L 719.023438 1078.707031 L 718.507812 1079.164062 Z M 716.347656 1076.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 735.046875 1061.59375 L 731.324219 1058.6875 C 735.824219 1052.914062 739.796875 1046.753906 743.203125 1040.273438 L 743.507812 1039.683594 L 747.710938 1041.859375 L 747.386719 1042.46875 C 743.859375 1049.199219 739.722656 1055.601562 735.046875 1061.59375 Z M 735.046875 1061.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 586.65625 1106.515625 C 579.414062 1104.230469 572.378906 1101.339844 565.617188 1097.878906 L 567.777344 1093.671875 C 574.300781 1097.011719 581.089844 1099.796875 588.078125 1102 L 587.328125 1104.378906 L 588.082031 1102.003906 L 588.71875 1102.203125 L 587.308594 1106.71875 Z M 586.65625 1106.515625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 678.1875 1102.359375 L 678.625 1103.464844 C 671.550781 1106.230469 664.261719 1108.398438 656.832031 1109.953125 L 655.863281 1105.324219 C 663.035156 1103.824219 670.070312 1101.726562 676.894531 1099.0625 L 677.523438 1098.8125 L 679.253906 1103.214844 L 678.625 1103.464844 Z M 678.1875 1102.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 610.195312 1111.714844 L 610.808594 1107.023438 C 618.078125 1107.964844 625.414062 1108.320312 632.742188 1108.082031 L 633.414062 1108.058594 L 633.582031 1112.789062 L 632.894531 1112.8125 C 625.3125 1113.054688 617.722656 1112.6875 610.195312 1111.714844 Z M 610.195312 1111.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#865e2ae16d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.640625 606.964844 L 0.265625 606.964844 L 0.265625 611.699219 L 22.640625 611.699219 Z M 22.640625 606.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.f38720a60a983022cf0cc1a10c3402c9.svg";
export { ForwardRef as ReactComponent };